// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1XKkm","alertIcon":"ConfirmModal_alertIcon__1ZhNh"};